var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('file-upload',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.allowFiles),expression:"$route.meta.allowFiles"}]}),_c('notes',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.allowNotes),expression:"$route.meta.allowNotes"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }